"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MockError = exports.MockSuccess = void 0;

var _DataService = require("../DataService");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var MockSuccess = function MockSuccess(responseBody) {
  _classCallCheck(this, MockSuccess);

  this.responseBody = responseBody;
};

exports.MockSuccess = MockSuccess;

var MockError = function MockError() {
  var statusCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
  var message = arguments.length > 1 ? arguments[1] : undefined;

  _classCallCheck(this, MockError);

  this.statusCode = statusCode;
  this.message = message;
};

exports.MockError = MockError;

var MockDataService = /*#__PURE__*/function () {
  function MockDataService(handlers) {
    var _this = this;

    _classCallCheck(this, MockDataService);

    _defineProperty(this, "middleware", function (store) {
      return function (next) {
        return function (action) {
          var handler = _this.handlers[action.type];

          if (handler) {
            handler(action).then(function (result) {
              var newAction = _this.createNextAction(action, result);

              next(newAction);
            });
          }

          return next(action);
        };
      };
    });

    if (_typeof(handlers) !== 'object') {
      throw new Error('MockDataService constructor requires an object of type handlers');
    }

    this.handlers = handlers;
  }

  _createClass(MockDataService, [{
    key: "createNextAction",
    value: function createNextAction(action, result) {
      var actionDefaults = {
        originalPayload: action.payload,
        identifier: action.identifier
      };

      if (result instanceof MockSuccess) {
        var body = result.responseBody;

        if (Array.isArray(body)) {
          body = {
            results: body
          };
        }

        return _objectSpread({}, actionDefaults, {
          type: action.type + _DataService.ActionStates.SUCCESS,
          payload: {
            data: body,
            error: null
          }
        });
      } else {
        return _objectSpread({}, actionDefaults, {
          type: action.type + _DataService.ActionStates.ERROR,
          payload: {
            data: {
              statusCode: result.statusCode,
              message: result.message
            },
            error: 'Error'
          }
        });
      }
    }
  }]);

  return MockDataService;
}();

var _default = MockDataService;
exports["default"] = _default;